import { Car } from "./car.model"
import { Company } from "./company.model"
import { Container } from "./container.model"
import { DeviceLatestStatus } from "./device-latest-status.model"
import { PoligonDetail } from "./poligon.model"

export class Shift {
    public id?: number
    public status?: boolean
    public complated?: boolean
    public description?: string
    public startDate?: Date
    public endDate?: Date
    public removeStatus?:boolean
    public companyId?: number
    public carId?: number
    public containers?: Array<Container>
    //    public personels?:string
    public car?: Car
    public company?: Company
}

export class ShiftContainer {
    public Id?: number
    public shiftId?: number
    public containerId?: number
    public shift?: Shift
    public container?: Container
}

export class ShiftContainerRequest {
    public car?: Car
    public shift?: Shift
    public container?: Container
}